import utils from '@/utils';
import { onBeforeUnmount, onMounted, reactive, toRefs } from 'vue';

const useScrollY = () => {
  const state = reactive({
    scrollTop: 0,
    direction: 'down',
  });
  const onScroll = () => {
    const scrollTop = utils.dom.getScrollTop();
    const _direction = scrollTop > state.scrollTop ? 'down' : 'up';
    state.scrollTop = scrollTop;
    state.direction = _direction;
  };
  onMounted(() => {
    window.addEventListener('scroll', onScroll, { passive: true });
  });
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll);
  });
  return { ...toRefs(state) };
};
export default useScrollY;
